<link
  [href]="typeface || '' | safeHtml: 'bypassSecurityTrustResourceUrl'"
  rel="stylesheet"
/>

<router-outlet>
  @if (isAppLoading) {
    <div class="loader__mask">
      <div class="loader"></div>
    </div>
  }
</router-outlet>

<timeout-modal data-test-id="timeOutModal"> </timeout-modal>
